export default {
    emergencies:[],
    emergency:{},
}
